import { env } from "@web/lib/env";
import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
	baseURL: env.VITE_APP_API_HOST,
	fetchOptions: {
		credentials: "include",
	},
});

export const {
	signIn,
	signOut,
	signUp,
	useSession,
	revokeSession,
	getSession,
	...rest
} = authClient;
